import React from 'react';
import PropTypes from 'prop-types';
import { copyToClipboard } from 'utils';

const CopyToClipboard = ({
  text,
  children,
  className,
  successTitle = '',
  successDescription = '',
  errorTitle = '',
  errorDescription = '',
}) => {
  return (
    <div
      onClick={() =>
        copyToClipboard(text, {
          successTitle,
          successDescription,
          errorTitle,
          errorDescription,
        })
      }
      className={className}
    >
      {children}
    </div>
  );
};

CopyToClipboard.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  successTitle: PropTypes.string,
  successDescription: PropTypes.string,
  errorTitle: PropTypes.string,
  errorDescription: PropTypes.string,
  children: PropTypes.node,
};

export default CopyToClipboard;
